'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_ENTITY_TYPE = undefined;
exports.default = entitiesReducerInitializer;

var _immutable = require('immutable');

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var REMOVE_ENTITY_TYPE = exports.REMOVE_ENTITY_TYPE = 'entities/REMOVE_BY_ID';

function entitiesReducerInitializer(INITIAL_STATE) {
  return function entitiesReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    if (action.type === REMOVE_ENTITY_TYPE) {
      var _action$payload = action.payload,
          collectionName = _action$payload.collectionName,
          key = _action$payload.key;
      return state.deleteIn([collectionName, key]);
    } // Actions like @@redux/INIT do not have a payload


    if (!action.payload || !action.payload.entities) {
      return state;
    }

    var entities = action.payload.entities;
    return state.merge((0, _mapValues2.default)(entities, function (collection, collectionName) {
      return state.get(collectionName).merge(new _immutable.Map(collection));
    }));
  };
}